<template>
  <div class="base">
    <inside-header title="选择城市" />
    <div class="main">
      <div class="container">
        <div class="head">
          <div class="hot-city-area">
            <span class="city" @click="handleSetRegion('北京市')">北京市</span>
            <span class="city" @click="handleSetRegion('上海市')">上海市</span>
            <span class="city" @click="handleSetRegion('成都市')">成都市</span>
            <span class="city" @click="handleSetRegion('重庆市')">重庆市</span>
            <span class="city" @click="handleSetRegion('天津市')">天津市</span>
          </div>
          <div class="select-city">
            <van-field
              readonly
              clickable
              name="area"
              :value="value"
              label="地区选择"
              placeholder="点击选择省市区"
              @click="showArea = true"
            />
            <van-popup v-model="showArea" position="bottom">
              <van-area
                :area-list="areaList"
                @confirm="onConfirm"
                @cancel="showArea = false"
              />
            </van-popup>
          </div>
          <div class="btn-area">
            <a-button type="primary" block @click="submitCity()">
              确定
            </a-button>
          </div>
        </div>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import { mapActions } from 'vuex'
import AeraInfo from '@/assets/js/area.js'

export default {
  name: 'ChangeCity',
  components: {
    MainFooter,
    InsideHeader
  },
  props: {
    page_type: {
      type: String,
      default: 'index'
    }
  },
  data() {
    return {
      loadding: true,
      // 选择城市
      divisionDefault: [],
      countryDivision: [],
      fieldNames: {
        label: 'name',
        value: 'name',
        children: 'children'
      },
      province: '',
      city: '',
      cityA: '',
      area: '',
      value: '',
      showArea: false,
      areaList: AeraInfo // 数据格式见 Area 组件文档
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    ...mapActions(['SetRegion']),
    countryDivisionChange(e) {
      this.province = e[0]
      this.city = e[1]
      this.area = e[2]
    },
    loadData() {
      this.$http({
        url: '/index/index/loadCity',
        method: 'get'
      }).then((res) => {
        this.countryDivision = res.data
        this.loadding = false
      })
    },
    onConfirm(values) {
      console.log(values)
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.showArea = false
      this.city = values[1].name
      this.cityA = values[2].name
    },
    cityFilter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      )
    },
    handleSetRegion(region) {
      const { SetRegion } = this
      SetRegion(region).then(() => {
        this.$router.go(-1)
      })
    },
    submitCity() {
      console.log(this.city)
      if (this.city === '') {
        this.$toast.fail('还未选择城市哦~')
      } else {
        this.handleSetRegion(this.city)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  margin-top: 10px;
  width: 100%;
  padding: 15px;

  .container {
    background-color: #fff;
    margin: auto;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(216,216,216,0.3);
    text-align: left;

    .head {

      .span-title {
        font-family: MicrosoftYaHeiLight;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333;

        margin-right: 20px;
      }

      .hot-city-area {
        line-height: 22px;

        .city {
          font-family: MicrosoftYaHeiLight;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: $theme-color;

          padding-right: 13px;
        }
      }

      .select-city {
        margin-top: 20px;
      }

      .btn-area {
        margin-top: 20px;
        button {
          height: 40px;
          background-color: #ff5c00;
          border-radius: 10px;
        }
      }

    }
  }
}
</style>
